export class HrGoal {
    id!: string
    name!: string
    userId!: number
    goal1!: number
    goal2!: number
    goalDirection!: number
    format!: string
    isCalculated!: boolean
    canEditHistorical!: boolean
    order!: number
    showAverage!: boolean
    showSum!: boolean
    isArchived!: boolean
    useRolling12Months!: boolean
    notes!: string

    average!: number
    sum!: number
    currentValue!: number
    weekValues!: any
    weeklyOaValues!: any // this is for sorting the columns

    meetingId!: string
    meetingNames!: string[]
}
